<template>
  <div class="popover-ai-link" ref="popover" :style="containerStyle">
    <div class="ai-options" :class="{
      'show-options': showOptions,
      'position-bottom': menuPosition.isBottom,
      'position-right': menuPosition.isRight,
      'position-top': menuPosition.isTop,
      'position-left': menuPosition.isLeft
    }">
      <div class="option" @click="handleOptionClick('ai-qa')">{{popoverNames.aiQa}}</div>
      <div class="option" @click="handleOptionClick('knowledge_employee')">{{popoverNames.knowledgeEmployee}}</div>
      <div class="option" @click="handleOptionClick('ai_search')">{{popoverNames.aiSearch}}</div>
    </div>
    <div class="ai-button"
      @mousedown="startDrag"
      @click="handleButtonClick"
      @touchstart="startDrag">
      <img src="@/assets/ai-icon.png" alt="AI" class="ai-icon">
    </div>
  </div>
</template>

<script>
import config from '../../config'
import {i18n} from '@/utils/i18n'

const popoverNames = {
  aiQa: i18n.t('ai.aiQa'),
  knowledgeEmployee: i18n.t('ai.knowledgeEmployee'),
  aiSearch: i18n.t('ai.aiSearch')
}
export default {
  name: 'PopoverAiLink',
  data () {
    return {
      showOptions: false,
      isDragging: false,
      position: {
        x: window.innerWidth - 76,
        y: window.innerHeight - 156
      },
      dragOffset: {
        x: 0,
        y: 0
      },
      menuPosition: {
        isTop: true,
        isRight: true
      },
      popoverNames
    }
  },
  computed: {
    containerStyle () {
      return {
        transform: `translate(${this.position.x}px, ${this.position.y}px)`,
        position: 'fixed',
        top: '0',
        left: '0',
        margin: '0'
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('mousemove', this.handleDrag)
    document.addEventListener('mouseup', this.stopDrag)
    document.addEventListener('touchmove', this.handleDrag)
    document.addEventListener('touchend', this.stopDrag)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('mousemove', this.handleDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    document.removeEventListener('touchmove', this.handleDrag)
    document.removeEventListener('touchend', this.stopDrag)
  },
  methods: {
    getDefaultStyle (buttonHeight, padding) {
      return {
        top: `${buttonHeight + padding}px`,
        right: `${buttonHeight + padding}px`,
        bottom: 'auto',
        left: 'auto'
      }
    },
    handleButtonClick () {
      if (!this.isDragging) {
        this.toggleOptions()
      }
    },
    toggleOptions () {
      this.showOptions = !this.showOptions
    },
    startDrag (event) {
      let clientX, clientY
      this.showOptions = false
      if (event.type === 'touchstart') {
        clientX = event.touches[0].clientX
        clientY = event.touches[0].clientY
      } else {
        clientX = event.clientX
        clientY = event.clientY
      }

      this.isDragging = true
      const rect = this.$refs.popover.getBoundingClientRect()
      this.dragOffset.x = clientX - rect.left
      this.dragOffset.y = clientY - rect.top
    },
    handleDrag (event) {
      if (!this.isDragging) return

      let clientX, clientY
      if (event.type === 'touchmove') {
        clientX = event.touches[0].clientX
        clientY = event.touches[0].clientY
      } else {
        clientX = event.clientX
        clientY = event.clientY
      }

      event.preventDefault()

      const buttonWidth = 56
      const buttonHeight = 56
      const popoverHeight = 157
      const popoverWidth = 160

      // 计算可移动的边界
      const minX = 0
      const maxX = window.innerWidth - buttonWidth
      let minY = 0
      const maxY = window.innerHeight - buttonHeight

      // 计算新位置
      let newX = clientX - this.dragOffset.x
      let newY = clientY - this.dragOffset.y

      // 限制在可视范围内
      newX = Math.min(Math.max(minX, newX), maxX)
      newY = Math.min(Math.max(minY, newY), maxY)

      // 更新位置
      this.position.x = newX
      this.position.y = newY
      // 超过顶
      const isTop = clientY > popoverHeight
      const isBottom = window.innerHeight - clientY - 64 > popoverHeight
      const isRight = window.innerWidth - clientX < popoverWidth
      const isLeft = clientX < popoverWidth
      console.log(window.innerHeight - clientY - 64)
      // 更新菜单位置
      this.updateMenuPosition(isTop, isBottom, isLeft, isRight)
    },
    stopDrag () {
      this.isDragging = false
    },
    handleClickOutside (event) {
      const popover = this.$refs.popover
      if (popover && !popover.contains(event.target) && this.showOptions) {
        this.showOptions = false
      }
    },
    updateMenuPosition (isTop, isBottom, isLeft, isRight) {
      this.menuPosition = {isTop, isBottom, isLeft, isRight}
    },
    handleOptionClick (option) {
      this.$emit('option-selected', option)
      let url = ''
      switch (option) {
        case 'ai-qa':
          url = 'https://v2.fangcloud.com/ai-knowledge/all/ac3563f2-0558-48ed-abe8-bb6dce3762e3'
          window.open(url, '_blank')
          break
        case 'knowledge_employee':
        case 'ai_search':
          const redirectUrl = `https://h5v3.fangcloud.com/?route=${option}`
          const h5Url = `${config.imageUrl}/third_party/oauth/v3_h5_redirect?redirect=${encodeURIComponent(redirectUrl)}`
          window.open(h5Url, '_blank')
          break
      }

      this.showOptions = false
    }
  }
}
</script>

<style scoped>
.popover-ai-link {
  z-index: 999;
  width: max-content;
  user-select: none;
}

.popover-ai-link .ai-button {
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  transition: transform 0.3s ease;
  touch-action: none;
}

.popover-ai-link .ai-button:hover {
  transform: scale(1.05);
}

.popover-ai-link .ai-button .ai-icon {
  width: 40px;
  height: 40px;
  pointer-events: none;
}

.popover-ai-link .ai-options {
  position: absolute;
  right: 0;
  bottom: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  cursor: default;
  min-width: 96px;
  z-index: 1000;
}

.popover-ai-link .ai-options.show-options {
  opacity: 1;
  visibility: visible;
}

.popover-ai-link .ai-options.position-top {
  bottom: 45px;
  top: unset;
}

.popover-ai-link .ai-options.position-left {
  left: 21px;
  right: unset;
}
.popover-ai-link .ai-options.position-bottom {
  top: 64px;
  bottom: unset;
}

.popover-ai-link .ai-options.position-right {
  right: 21px;
  left: unset
}

.popover-ai-link .ai-options .option {
  padding: 4px 16px;
  white-space: nowrap;
  cursor: pointer;
  line-height: 24px;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.popover-ai-link .ai-options .option:hover {
  background-color: #f5f5f5;
}
</style>
